import { DatePipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-package-report',
  templateUrl: './package-report.component.html',
  styleUrl: './package-report.component.scss'
})
export class PackageReportComponent {

  today: any;
  startDate: any;
  endDate: any;
  selectedPkdId: any;
  packageData: any
  packageName: any
  groupedPackageData: any;

  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<PackageReportComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data1: any,
    private service: DigisubservicesService
  ) {
    this.today = formatDate(new Date(), 'yyyy/MM/dd', 'en-IN', 'GMT+0530');
  }

  ngOnInit(): void {
    debugger
    this.startDate = this.data1['startDate'];
    this.endDate = this.data1['endDate'];
    this.selectedPkdId = this.data1['selectedPackageId'];
    this.getPackageReportData();
  }

  getPackageReportData() {
    this.service.getPackageReportData(this.selectedPkdId, this.startDate, this.endDate)
      .subscribe({
        next: (res) => {
          debugger
          this.packageName = res[0].pkg_name;
          this.packageData = res;

          this.groupPackagesByOfficeRep();
        },
        error: (err) => {
          console.error('Failed to load package report data', err);
          this.packageData = [];
        }
      });
  }

  groupPackagesByOfficeRep() {
    this.groupedPackageData = this.packageData.reduce((groups, item) => {
      const officeRep = item.sub_off_rep_name || 'Unknown';
      if (!groups[officeRep]) {
        groups[officeRep] = [];
      }
      groups[officeRep].push(item);
      return groups;
    }, {});
  }

  getGroupTotalAmount(items: any[]): number {
    const total = items.reduce((sum, item) => {
      const amt = parseFloat(item.total_pkg_amt);
      return sum + (isNaN(amt) ? 0 : amt);
    }, 0);
    return parseFloat(total.toFixed(2));
  }

  getGroupTotalPackages(items: any[]): number {
    const total = items.reduce((sum, item) => {
      const count = parseFloat(item.no_of_packages);
      return sum + (isNaN(count) ? 0 : count);
    }, 0);
    return parseFloat(total.toFixed(2));
  }

}